<h3>{{'How to proceed?' | translate }}</h3>
<div class="row justify-content-around align-content-center art-group h-75">
  <div class="col-12 col-md-4 pb-4 art-group-index">
    <a (click)="onEmployeeClick()">
      <div class="art-box art-box-index">
        <div>
          <div>
            <app-h2-adapting-size [text]="'I have a card'"></app-h2-adapting-size>
          </div>
        </div>
      </div>
    </a>
  </div>
  <div class="col-12 col-md-4 pb-4 art-group-index" [class.disabled]="disableGuest">
    <a (click)="onGuestClick()">
      <div class="art-box art-box-index" [class.disabled]="disableGuest">
        <div>
          <div>
            <app-h2-adapting-size [text]="'I don\'t have a card'"></app-h2-adapting-size>
          </div>
        </div>
      </div>
    </a>
  </div>
  <!-- <div class="col-12 col-sm-3">
    <app-button [title]="'As Employee' | translate" (clickEvent)="onEmployeeClick()" [isLeftStyle]="true"></app-button>
  </div>
  <div class="col-12 col-sm-3">
    <app-button [title]="'As Guest' | translate" (clickEvent)="onGuestClick()" [isLeftStyle]="true"></app-button>
  </div> -->
</div>
